import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Gallery Saga ***************************
export function* fetchGallerySaga(action) {
  // console.log('action: ', action);
  try {
    // console.log('Here');
    yield put(Creators.fetchGalleryStart());
    let url;
    // if (action.pageNumber === 1) {
    url = yield `${apiEndpoints.gallery}/${action.slug}`;
    // } else {
    // url = yield `${apiEndpoints.galleryData}/${action.tagName}/10/page/${
    // action.pageNumber
    // }`;
    // }
    // console.log('url: ', url);

    const res = yield axios.get(url);
    // console.log('res: ', res);
    const galleryData = [];
    // if (res.data.success === 1) {
    if (res.status === 200) {
      for (let key in res.data.gallery) {
        galleryData.push({
          id: key,
          ...res.data.gallery[key]
        });
      }
    }
    // console.log('galleryData: ', galleryData);
    yield put(Creators.fetchGallerySuccess(galleryData));
  } catch (err) {
    yield put(Creators.fetchGalleryFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Old Gallery Saga ***************************
export function* fetchOldGallerySaga(action) {
  // console.log('action: ', action);
  try {
    // console.log('Here');
    yield put(Creators.fetchOldGalleryStart());
    let url;
    // if (action.pageNumber === 1) {
    url = yield `${apiEndpoints.oldGallery}/${action.slug}`;
    // } else {
    // url = yield `${apiEndpoints.galleryData}/${action.tagName}/10/page/${
    // action.pageNumber
    // }`;
    // }
    // console.log('url: ', url);

    const res = yield axios.get(url);
    console.log('res: ', res);
    const oldGalleryData = [];
    if (res.data.success === 1) {
      // if (res.status === 200) {
      for (let key in res.data.gallery) {
        oldGalleryData.push({
          id: key,
          ...res.data.gallery[key]
        });
      }
    }
    console.log('oldGalleryData: ', oldGalleryData);
    yield put(Creators.fetchOldGallerySuccess(oldGalleryData));
  } catch (err) {
    yield put(Creators.fetchOldGalleryFailure(err));
  }
}
// ______________________________________________________________________________
